// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'
let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
    getGunEnum() {
        return http.requestGet(apiPre + service.res + '/res/gun/getGunEnum')
      },
  // 地锁列表查询
  lockList(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/lock/status/getPageList', params)
  },
  // 地锁状态查询
  getLockStatusEnum(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/lock/status/getLockStatusEnum', params)
  },
  // 场站id获取枪
  getEffectiveGunsByStationId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/getEffectiveGunsByStationId', params)
  },
   // 新增
   addlock(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/lock/status/add', params)
  },
  //删除
  delLock(id) {
    return http.requestDelete(apiPre + service.res + '/res/lock/status/del/' + id, {})
  },
//修改状态
  updBillSwitch(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/lock/status/updBillSwitch/'+ params, {})
  },
  
  
  
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/lockApi.js